// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Spacer_spacer__dInco","withBorder":"Spacer_withBorder__HD777"};